import React, { useState, useCallback, useEffect } from 'react';
import fetchCustom from '../fetchCustom';

export const GET = 'get';
export const POST = 'post';
export const PUT = 'put';
export const DELETE = 'delete';

export const request = (url, options = {}) => {
    const { method = GET, payload, ...otherOptions } = options;
    
    return new Promise((resolve, reject) => {
        const fetchOptions = {
            method: method.toUpperCase(),
            headers: {
                'Content-Type': 'application/json',
                ...otherOptions.headers
            },
            ...otherOptions
        };
        
        if (payload) {
            fetchOptions.body = typeof payload === 'string' ? payload : JSON.stringify(payload);
        }
        
        fetchCustom(url, fetchOptions)
            .then(response => response.json())
            .then(resolve)
            .catch(reject);
    });
};

// Hook function (for components that need it)
const useFetch = (method = GET, url) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);
    
    const dispatch = useCallback(async (options = {}) => {
        try {
            setLoading(true);
            setErrors({});
            setErrorMessage(null);
            
            const response = await request(url || options.url, {
                method,
                ...options
            });
            
            setData(response);
            return response;
        } catch (error) {
            console.error('🔧 useFetch error:', error);
            setErrorMessage(error.message || 'Request failed');
            setErrors({ general: error.message || 'Request failed' });
            throw error;
        } finally {
            setLoading(false);
        }
    }, [method, url]);
    
    return {
        data,
        loading,
        errors,
        errorMessage,
        dispatch
    };
};

export default useFetch;
